import React from 'react';
import { Activity, Clock, MapPin, TrendingUp } from 'lucide-react';

/**
 * Tracking Tab Component
 * Placeholder for future tracking features
 */
const TrackingTab = () => {
    return (
        <div className="flex items-center justify-center h-full bg-gradient-to-br from-gray-50 to-blue-50">
            <div className="text-center max-w-2xl px-4">
                <div className="inline-flex items-center justify-center w-24 h-24 bg-green-100 rounded-full mb-6">
                    <Activity className="text-green-600" size={48} />
                </div>

                <h2 className="text-3xl font-bold text-gray-800 mb-4">
                    Tracking Coming Soon
                </h2>

                <p className="text-gray-600 mb-8 text-lg">
                    This feature is under development and will include real-time tracking capabilities for your field operations.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-left">
                    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
                        <div className="flex items-center gap-3 mb-3">
                            <div className="p-2 bg-blue-100 rounded-lg">
                                <MapPin className="text-blue-600" size={24} />
                            </div>
                            <h3 className="font-semibold text-gray-800">GPS Tracking</h3>
                        </div>
                        <p className="text-sm text-gray-600">
                            Real-time location tracking for field workers and vehicles
                        </p>
                    </div>

                    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
                        <div className="flex items-center gap-3 mb-3">
                            <div className="p-2 bg-purple-100 rounded-lg">
                                <Clock className="text-purple-600" size={24} />
                            </div>
                            <h3 className="font-semibold text-gray-800">Time Tracking</h3>
                        </div>
                        <p className="text-sm text-gray-600">
                            Track time spent on jobs and calculate labor costs
                        </p>
                    </div>

                    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
                        <div className="flex items-center gap-3 mb-3">
                            <div className="p-2 bg-green-100 rounded-lg">
                                <TrendingUp className="text-green-600" size={24} />
                            </div>
                            <h3 className="font-semibold text-gray-800">Analytics</h3>
                        </div>
                        <p className="text-sm text-gray-600">
                            Performance metrics and productivity insights
                        </p>
                    </div>
                </div>

                <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm text-blue-800">
                        <strong>Note:</strong> Have specific tracking requirements? Contact support to discuss your needs and timeline.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TrackingTab;
